import React, { Component } from 'react'
import './styles.css'
import Util from '../../classes/util'


const estadoInicial = {
}

class ListaProdutos extends Component {

    state = {
        ...estadoInicial,
    }

    calculateTotalValue = (produtos) => {
        let valor = 0;

        produtos.forEach((produto) => {
            valor += (produto.preco * produto.quantidade);
        });

        this.props.setValorTotal(valor);
    }

    addProduct = (produto) => {
        const escolhidos = this.props.produtosEscolhidos;
        let { produtosEscolhidos } = this.props

        if (escolhidos.find((p) => p.chave == produto.chave)) {
            produtosEscolhidos = escolhidos.map((p) => p.chave == produto.chave ? ({ ...p, quantidade: parseInt(p.quantidade) + 1 }) : ({ ...p }));
        } else {
            produtosEscolhidos = [...produtosEscolhidos, { ...produto, quantidade: 1 }];
        }

        this.props.setProdutosEscolhidos(produtosEscolhidos);
        this.calculateTotalValue(produtosEscolhidos);
    }

    removeProduct = (produto) => {
        let { produtosEscolhidos } = this.props
        const escolhido = this.props.produtosEscolhidos.find((p) => p.chave == produto.chave);
        if (!escolhido) {
            return;
        }

        if (escolhido?.quantidade > 1) {
            produtosEscolhidos = produtosEscolhidos.map((p) => p.chave == produto.chave ? ({ ...p, quantidade: parseInt(p.quantidade) - 1 }) : ({ ...p }));
        } else {
            produtosEscolhidos.splice(produtosEscolhidos.findIndex((p) => p.chave == produto.chave), 1);

        }
        this.props.setProdutosEscolhidos(produtosEscolhidos);
        this.calculateTotalValue(produtosEscolhidos);
    }

    setQuantity = (produto, quantidade) => {
        if (!this.props.maxValue || this.props.maxValue && this.props.maxValue >= this.props.valorTotal + produto.preco * (quantidade - (this.props.produtosEscolhidos.find((prod) => prod.chave == produto.chave) ? this.props.produtosEscolhidos.find((prod) => prod.chave == produto.chave).quantidade : 0))) {
            const produtoEscolhido = this.props.produtosEscolhidos.find((p) => p.chave === produto.chave);
            let { produtosEscolhidos } = this.props

            if (produtoEscolhido && quantidade > 0) {
                produtosEscolhidos = this.props.produtosEscolhidos.map((p) => p.chave === produto.chave ? ({ ...p, quantidade }) : ({ ...p }));
            } else if (produtoEscolhido && quantidade <= 0) {
                produtosEscolhidos = this.props.produtosEscolhidos.filter((p) => p.chave !== produto.chave);
            } else if (quantidade > 0) {
                produtosEscolhidos = [...this.props.produtosEscolhidos, { ...produto, quantidade }];
            }

            this.props.setProdutosEscolhidos(produtosEscolhidos);
            this.calculateTotalValue(produtosEscolhidos);
        }
    }

    render() {
        return (
            <div>
                <div className='produtos_lista'>
                    {this.props.produtos.map((p) => (
                        <div key={p.chave} className={`produtos_lista_item ${this.props.produtosEscolhidos.find((prod) => prod.chave == p.chave) ? "produtos_lista_item_selected" : ""}`}>
                            <div className='produtos_lista_fim_linha'>R$ {Util.formatarDinheiro(p.preco)} - {p.Descricao}</div>
                            <div className='produtos_lista_fim_linha'>
                                <div className='produtos_lista_buttons'>

                                    <button
                                        className="produtos_lista_minus"
                                        disabled={this.props.blocked || (this.props.onlyOne && this.props.produtosEscolhidos[0] && !this.props.produtosEscolhidos.find((prod) => prod.chave == p.chave)) || !this.props.produtosEscolhidos.find((prod) => prod.chave == p.chave)}
                                        onClick={() => this.removeProduct(p)}>-
                                    </button>

                                    <input
                                        type="number"
                                        className='produtos_lista_quantidade'
                                        disabled={this.props.blocked || (this.props.onlyOne && this.props.produtosEscolhidos[0] && !this.props.produtosEscolhidos.find((prod) => prod.chave == p.chave))}
                                        value={this.props.produtosEscolhidos.find((prod) => prod.chave == p.chave) ? `${this.props.produtosEscolhidos.find((prod) => prod.chave == p.chave)?.quantidade}` : 0}
                                        onChange={(e) => this.setQuantity(p, e.currentTarget.value)}
                                        onClick={(e) => e.target.select()} />

                                    <button
                                        className='produtos_lista_add'
                                        disabled={Number(this.props.valorTotal?.toFixed(2)) + Number(p.preco?.toFixed(2)) > this.props.maxValue || this.props.blocked || (this.props.onlyOne && this.props.produtosEscolhidos[0] && !this.props.produtosEscolhidos.find((prod) => prod.chave == p.chave)) || (p.maxQtd && p.maxQtd === this.props.produtosEscolhidos.find((prod) => prod.chave == p.chave)?.quantidade)}
                                        onClick={() => this.addProduct(p)}>+
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        )
    }
}

export default (ListaProdutos)